import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import {
  MessageDialogState,
  MessageDialogVariant,
  closeMessageDialog,
  subscribeMessageDialog,
} from '../../common/messageDialog';

const VARIANT_CONFIG: Record<
  MessageDialogVariant,
  { titleClass: string; icon: React.ReactNode }
> = {
  danger: {
    titleClass: 'message-dialog-title-danger',
    icon: (
      <Icon.ExclamationTriangleFill
        size={56}
        className="message-dialog-icon-danger"
      />
    ),
  },
  warning: {
    titleClass: 'message-dialog-title-warning',
    icon: (
      <Icon.ExclamationTriangleFill
        size={56}
        className="message-dialog-icon-warning"
      />
    ),
  },
  info: {
    titleClass: 'message-dialog-title-info',
    icon: (
      <Icon.InfoCircleFill size={56} className="message-dialog-icon-info" />
    ),
  },
};

/**
 * Globalne, wyśrodkowane okno modalne dla komunikatów dla użytkownika.
 * Nie znika samoczynnie i nie da się go zamknąć kliknięciem w tło ani klawiszem Esc
 * – użytkownik musi świadomie potwierdzić przeczytanie komunikatu.
 *
 * Montowane jednokrotnie, globalnie (patrz NavMain). Sterowane przez
 * `showMessageDialog()` z modułu `common/messageDialog`.
 */
export const MessageDialogModal: React.FC = () => {
  const [state, setState] = useState<MessageDialogState | null>(null);

  useEffect(() => subscribeMessageDialog(setState), []);

  const variant = state?.variant ?? 'danger';
  const { titleClass, icon } = VARIANT_CONFIG[variant];

  return (
    <Modal
      show={!!state}
      onHide={closeMessageDialog}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      contentClassName="p-3 rounded-4"
    >
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className={`message-dialog-title ${titleClass}`}>
          {state?.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center px-4">
        <div className="mb-3">{icon}</div>
        <p className="message-dialog-message">{state?.message}</p>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center pb-4">
        <Button
          variant="primary"
          size="lg"
          className="px-5"
          autoFocus
          onClick={closeMessageDialog}
        >
          Rozumiem
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MessageDialogModal;
